import React from 'react';
import { MilitaryInstallationHomeSearch as MilitaryInstallationHomeSearch$1 } from '@zillow/zrs-cms';

var BlockMilitaryInstallationHomeSearch = function BlockMilitaryInstallationHomeSearch() {
  return /*#__PURE__*/React.createElement(MilitaryInstallationHomeSearch$1, null);
};
var MilitaryInstallationHomeSearch = BlockMilitaryInstallationHomeSearch;

export { MilitaryInstallationHomeSearch as default };
